import React from 'react'
import Link from 'gatsby-link'

import './header.css'

const Header = ({ siteTitle }) => (
  <div className="Header">
    <div className="HeaderGroup">
      <Link to="/">Irina Koepp</Link>
      <Link to="/contact">Kontakt</Link>
      <Link to="/offers">Angebote</Link>
      <Link to="/about">Über mich</Link>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js